import { useEffect,useState } from 'react';
import { Link,useLocation as location2 } from 'wouter';
import post from '../post';
import Loading from '../components/Loading';
import Alert from '../components/Alert';
import { is } from '@react-spring/shared';
import * as Constants from '../constants';


const logout=()=>{
    localStorage.removeItem('token');
    window.location.href='/login';
}
const Profile=()=> {
    const [loading,isLoading]=useState(true);
    const [userData,setUserData]=useState(null);
    const [alert,setAlert]=useState({isOpen:false,title:'',message:'',onClose:null});
    const [location,navigate]=location2();
    const [isEditing,setIsEditing]=useState(false);
    const appVersion='1.0.0';
    const guardarCambiosDatos=async()=>{
        isLoading(true);
        const nombre=document.getElementById('nombre').value.trim();
        const telefono=document.getElementById('telefono').value.trim();
        if(!nombre || !telefono){
            setAlert({isOpen:true,title:'Error',message:'Por favor, completa todos los campos.'});
            isLoading(false);
            return;
        }
        if(telefono.length!==10){
            setAlert({isOpen:true,title:'Error',message:'El número de teléfono debe tener 10 dígitos.'});
            isLoading(false);
            return;
        }
        const data=await post('updateUserData',{nombre:nombre,telefono:telefono});
        if(!data.result){
            setAlert({isOpen:true,title:'Error',message:data.motive||'Error al actualizar los datos del usuario.'});
            isLoading(false);
            return;
        }else{
            setAlert({isOpen:true,title:'Éxito',message:'Datos actualizados correctamente.',onClose:()=>{setIsEditing(false);fetchData();}});
            //setUserData(data.data);
        }
        isLoading(false);
    }
    const fetchData = async () => {
            isLoading(true);
            // Simulate data fetching
            const data=await post('getUserData',{});
            if(!data.result){
                setAlert({isOpen:true,title:'Error',message:data.motive||'Error al obtener los datos del usuario.',onClose:()=>{navigate('/')}});
                isLoading(false);
                return;
            }else{
                
                setUserData(data.data);
                console.log(data.data)
            }
            isLoading(false);
        };
    useEffect(() => {
        fetchData();
    }, []);
    return (
    <div id="webcrumbs">
            <div className="min-h-screen bg-neutral-50 relative pb-24 overflow-hidden text-neutral-700">
        <div className="absolute inset-0 bg-black/50 z-50 flex items-center justify-center">
                    <div className="bg-white w-full h-full max-w-md mx-auto overflow-y-auto relative animate-slideInUp">
                        <div className="sticky top-0 bg-white z-10 shadow-sm">
                            <div className="flex items-center justify-between p-4 border-b border-neutral-200">
                                <h2 className="text-lg font-bold">Perfil y Ajustes</h2>
                                <Link href="/">
                                    <button className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 transition-colors">
                                        <span className="material-symbols-outlined">close</span>
                                    </button>
                                </Link>
                            </div>
                        </div>

                        <div className="p-4 space-y-6">
                                        <Alert isOpen={alert.isOpen} title={alert.title} message={alert.message} onClose={() => {(alert.onClose&&alert.onClose());setAlert({ isOpen: false, title: '', message: '' });}} />

                            <Loading isOpen={loading} />
                            {!loading && (
                                <>
                                    {/* Profile Info Section */}
                                    <div className="flex items-center space-x-4 mb-6">
                                        <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center overflow-hidden border-2 border-primary-200">
                                            <span className="material-symbols-outlined text-4xl text-primary-600">person</span>
                                        </div>
                                <div>
                                    <h3 className="text-lg font-bold">{userData?.nombre}</h3>
                                    <p className="text-neutral-600">Cliente desde {userData?.f_create.substring(0, 4)}</p>
                                    <button className="text-primary-600 text-sm mt-1 font-medium hover:text-primary-700 transition-colors flex items-center"
                                        onClick={() => setIsEditing(!isEditing)}
                                    >
                                        <span className="material-symbols-outlined text-sm mr-1">edit</span>
                                        Editar Perfil
                                    </button>
                                </div>
                            </div>

                            {/* Personal Information Section */}
                            <div className="border-b border-neutral-200 pb-6">
                                <h3 className="font-bold mb-4">Datos Personales</h3>
                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-neutral-700 mb-1">
                                            Nombre Completo
                                        </label>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                id='nombre'
                                                placeholder="Juan Pérez"
                                                className="w-full p-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                                value={userData?.nombre}
                                                onChange={(e) => setUserData({ ...userData, nombre: e.target.value })}
                                            />
                                        ) : (
                                            <p className="text-neutral-600">{userData?.nombre}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-neutral-700 mb-1">Correo electrónico</label>
                                        {isEditing ? (
                                            <input
                                                type="email"
                                                id='email'
                                                placeholder="john.doe@example.com"
                                                className="w-full p-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                                value={userData?.email}
                                                disabled
                                            />
                                        ) : (
                                            <p className="text-neutral-600">{userData?.email}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-neutral-700 mb-1">
                                            Teléfono
                                        </label>
                                        {isEditing ? (
                                            <input
                                                type="tel"
                                                id="telefono"
                                                placeholder="5512345678"
                                                className="w-full p-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                                value={userData?.telefono}
                                                onChange={(e) => setUserData({ ...userData, telefono: e.target.value.replace(/\D/g, '') })}
                                                onKeyUp={(e) => {
                                                    const cleaned = e.target.value.replace(/\D/g, '');
                                                    e.target.value = cleaned;
                                                }}
                                            />
                                        ) : (
                                            <p className="text-neutral-600">{userData?.telefono}</p>
                                        )}
                                    </div>
                                    {/*<div>
                                        <label className="block text-sm font-medium text-neutral-700 mb-1">
                                            Birth Date
                                        </label>
                                        <input
                                            type="date"
                                            className="w-full p-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                                        />
                                    </div>*/}
                                    {isEditing && (
                                        <div className="mt-4">
                                            <button className="bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition-colors"
                                                onClick={guardarCambiosDatos}
                                            >
                                                Guardar Cambios
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                             <button className="w-full py-3 px-4 flex justify-between items-center rounded-lg hover:bg-neutral-50 transition-colors border-b border-neutral-200 pb-6"
                                onClick={()=>{navigate('/orderHistory')}}
                             >
                                    <div className="flex items-center space-x-3">
                                        <span className="material-symbols-outlined text-neutral-600">receipt_long</span>
                                        <span className="font-medium">Historial de pedidos</span>
                                    </div>
                                    <span className="material-symbols-outlined text-neutral-400">chevron_right</span>
                                </button>

                            {/* Addresses Section */}
                            <div className="border-b border-neutral-200 pb-6">
                                <div className="flex justify-between items-center mb-4">
                                    <h3 className="font-bold">Direcciones</h3>
                                    <button className="text-primary-600 font-medium hover:text-primary-700 transition-colors flex items-center"
                                        onClick={()=>{navigate('/editAddress/0');}}
                                    >
                                        <span className="material-symbols-outlined text-base mr-1">add</span>
                                        Agregar Nueva
                                    </button>
                                </div>
                                <div className="space-y-3">
                                    
                                    {userData?.direcciones?.map(el =>  (
                                        
                                            <div key={"dir"+el.id} className="border border-neutral-200 rounded-lg p-3 hover:shadow-md transition-shadow" onClick={()=>{navigate('/editAddress/'+el.id);}}>
                                                <span>{el.nombre} {el.paterno} {el.materno}</span>
                                                <div className="flex justify-between">
                                                    <div className="flex items-start space-x-2">
                                                        <span className="material-symbols-outlined text-primary-600 mt-0.5">
                                                            home
                                                        </span>
                                                        <div>
                                                            <p className="font-medium">{el.alias}</p>
                                                            <p className="text-sm text-neutral-600">
                                                                {el.calle}, {el.ext} {el.int ? `, Int. ${el.int}` : ''}, {el.colonia}, {el.delegacion}, {el.estado}, C.P. {el.cp}
                                                            </p>
                                                        </div>
                                                    </div>
                                                   
                                                    <span className="material-symbols-outlined text-neutral-400 hover:text-neutral-700 cursor-pointer">
                                                        edit
                                                    </span>
                                                </div>
                                            </div>
                                        )
                                    )}
                                    {(!userData?.direcciones || userData?.direcciones.length === 0) && (
                                        <p className="text-sm text-neutral-600">No hay direcciones disponibles.</p>
                                    )}
                                </div>
                            </div>

                            {/* Payment Methods Section 
                            <div className="border-b border-neutral-200 pb-6">
                                <div className="flex justify-between items-center mb-4">
                                    <h3 className="font-bold">Payment Methods</h3>
                                    <button className="text-primary-600 font-medium hover:text-primary-700 transition-colors flex items-center">
                                        <span className="material-symbols-outlined text-base mr-1">add</span>
                                        Add New
                                    </button>
                                </div>
                                <div className="space-y-3">
                                    <div className="border border-neutral-200 rounded-lg p-3 hover:shadow-md transition-shadow">
                                        <div className="flex justify-between">
                                            <div className="flex items-center space-x-2">
                                                <span className="material-symbols-outlined text-blue-600">
                                                    credit_card
                                                </span>
                                                <div>
                                                    <p className="font-medium">Visa •••• 1234</p>
                                                    <p className="text-sm text-neutral-600">Expires 05/26</p>
                                                </div>
                                            </div>
                                            <div className="flex items-center space-x-2">
                                                <div className="w-10 h-6 bg-blue-100 rounded flex items-center justify-center">
                                                    <span className="text-xs font-bold text-blue-800">Default</span>
                                                </div>
                                                <span className="material-symbols-outlined text-neutral-400 hover:text-neutral-700 cursor-pointer">
                                                    more_vert
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="border border-neutral-200 rounded-lg p-3 hover:shadow-md transition-shadow">
                                        <div className="flex justify-between">
                                            <div className="flex items-center space-x-2">
                                                <span className="material-symbols-outlined text-red-600">
                                                    credit_card
                                                </span>
                                                <div>
                                                    <p className="font-medium">Mastercard •••• 5678</p>
                                                    <p className="text-sm text-neutral-600">Expires 11/25</p>
                                                </div>
                                            </div>
                                            <span className="material-symbols-outlined text-neutral-400 hover:text-neutral-700 cursor-pointer">
                                                more_vert
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>*/}

                            {/* Additional Options */}
                            <div className="space-y-4">
                                {/*<button className="w-full py-3 px-4 flex justify-between items-center rounded-lg hover:bg-neutral-50 transition-colors">
                                    <div className="flex items-center space-x-3">
                                        <span className="material-symbols-outlined text-neutral-600">
                                            notifications
                                        </span>
                                        <span className="font-medium">Notification Preferences</span>
                                    </div>
                                    <span className="material-symbols-outlined text-neutral-400">chevron_right</span>
                                </button>*/}

                                <a className="w-full py-3 px-4 flex justify-between items-center rounded-lg hover:bg-neutral-50 transition-colors"
                                    target='_blank'
                                    href={Constants.BASE_URL+"clienteappserver/legal/tandc"}
                                >
                                    <div className="flex items-center space-x-3">
                                        <span className="material-symbols-outlined text-neutral-600">description</span>
                                        <span className="font-medium">Términos y Condiciones</span>
                                    </div>
                                    <span className="material-symbols-outlined text-neutral-400">chevron_right</span>
                                </a>

                                <a className="w-full py-3 px-4 flex justify-between items-center rounded-lg hover:bg-neutral-50 transition-colors"
                                    target='_blank'
                                    href={Constants.BASE_URL+"clienteappserver/legal/privacy"}
                                >
                                    <div className="flex items-center space-x-3">
                                        <span className="material-symbols-outlined text-neutral-600">lock</span>
                                        <span className="font-medium">Aviso de Privacidad</span>
                                    </div>
                                    <span className="material-symbols-outlined text-neutral-400">chevron_right</span>
                                </a>

                                {/*<button className="w-full py-3 px-4 flex justify-between items-center rounded-lg hover:bg-neutral-50 transition-colors">
                                    <div className="flex items-center space-x-3">
                                        <span className="material-symbols-outlined text-neutral-600">help</span>
                                        <span className="font-medium">Help & Support</span>
                                    </div>
                                    <span className="material-symbols-outlined text-neutral-400">chevron_right</span>
                                </button>*/}

                                <button className="w-full mt-6 py-3 text-red-600 font-medium border border-red-200 rounded-lg hover:bg-red-50 transition-colors" onClick={logout}>
                                   Cerrar sesión
                                </button>
                            </div>
                                </>
                            )}
                        </div>

                        <div className="p-4 bg-neutral-50 text-center text-xs text-neutral-500">
                            <p>App  v{appVersion}</p>
                            <p>© 2025 administraT. Todos los derechos reservados.</p>
                            {/* Next: "Add language selector dropdown" */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
                );
}

export default Profile;